module.exports = __webpack_public_path__ + "static/media/ivan_soccer.7bb5de91.png";